import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";
import CompanyPage from "./CompanyPage";
import CertificatePage from "./CertificatePage";
import SingleTypeCertificatePage from "./SingleTypeCertificatePage";
import MemberAreaPage from "./MemberArea";
import ProfilePage from "./ProfilePage";
import ConfirmationPage from "./ConfirmationPage";
import RequestResetPasswordPage from "./RequestResetPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import WhitePaperPage from "./WhitepaperPage";
import RouteToRegister from "../Routes/RouteToRegister";

export const PAGE_LIST = {
  LOGIN: '/login',
  CERTIFICATE: '/certificate',
  PVP: '/certificate/pvp',
  APPROVAL: '/certificate/approval',
  COMPANY: '/company/:companyName',
  REGISTER: '/register',
  MEMBER_AREA: '/company/:companyName/member',
  PROFILE: '/profile',
  EMAIL_CONFIRMED: '/confirmed',
  REQUEST_RESET_PASSWORD: '/reset-password/request',
  RESET_PASSWORD: '/reset-password',
  WHITE_PAPER: '/whitepaper/:name',
}

export function createMemberAreaLink(companyName) {
  return `/company/${companyName}/member`;
}

export function createCompanyLink(companyName) {
  return `/company/${companyName}`;
}

export function createCertainCertificateLink(type) {
  return `${PAGE_LIST.CERTIFICATE}?type=${type}`
}

const login = {
  name: 'Login',
  path: PAGE_LIST.LOGIN,
  component: <LoginPage />,
};

const register = {
  name: 'Register',
  path: PAGE_LIST.REGISTER,
  component: <RegisterPage />,
};

const certificate = {
  name: 'Certificate',
  path: PAGE_LIST.CERTIFICATE,
  component: <CertificatePage />,
}

const requestResetPasswordPage = {
  name: 'Request Reset Password',
  path: PAGE_LIST.REQUEST_RESET_PASSWORD,
  component: <RequestResetPasswordPage />,
}

const PAGES = [
  {
    name: 'Company',
    path: PAGE_LIST.COMPANY,
    component: <CompanyPage />,
  },
  {
    name: 'PVP',
    path: PAGE_LIST.PVP,
    component: <SingleTypeCertificatePage type={SingleTypeCertificatePage.TYPE.PVP} />,
  },
  {
    name: 'Approval',
    path: PAGE_LIST.APPROVAL,
    component: <SingleTypeCertificatePage type={SingleTypeCertificatePage.TYPE.APPROVAL} />,
  },
  login,
  register,
  {
    name: 'Profile',
    path: PAGE_LIST.PROFILE,
    privateRoute: true,
    component: <ProfilePage />,
  },
  {
    name: 'Member Area',
    privateRoute: true,
    path: PAGE_LIST.MEMBER_AREA,
    component: <MemberAreaPage />
  },
  {
    name: 'Email confirmed',
    path: PAGE_LIST.EMAIL_CONFIRMED,
    component: <ConfirmationPage />
  },
  requestResetPasswordPage,
  {
    name: 'Reset Password',
    path: PAGE_LIST.RESET_PASSWORD,
    component: <ResetPasswordPage />,
  },
  {
    name: 'Download whitepaper',
    path: PAGE_LIST.WHITE_PAPER,
    component: (
      <RouteToRegister>
        <WhitePaperPage />
      </RouteToRegister>
    ),
  },
  certificate,
];

export const PAGES_ENUM = {
  LOGIN_PAGE: login,
  CERTIFICATE_PAGE: certificate,
  REGISTER_PAGE: register,
}

export default PAGES;